<div class="lmo-frac-fctv-overflow" *ngIf="vendorArray">
  <h2>Overflow Vendors</h2>
  <div class="form">
    <ng-container *ngIf="(overflowVendors$ | async).length; else noOverflowVendors">
      <div
        class="vendor-row"
        [formGroup]="vendorArray"
        *ngFor="let vendor of vendorArray.controls; let i = index; trackBy: trackById"
      >
        <mat-checkbox
          [formControl]="vendor.get('isOverflow')"
          [checked]="vendor.get('isOverflow')"
          [matTooltip]="getVendorName(vendor)"
          [disabled]="!this.userService.isAdmin()"
          >{{ getVendorName(vendor) }}</mat-checkbox
        >
        <mat-form-field>
          <mat-label>Contract</mat-label>
          <mat-select [formControl]="vendor.get('contract')">
            <mat-option *ngFor="let contract of getContractChoices(vendor); trackBy: trackById" [value]="contract">
              {{ contract.contractName }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </ng-container>
    <ng-template #noOverflowVendors>
      <div class="pb-3">
        No Overflow Vendors Available
      </div>
    </ng-template>
  </div>
  <div class="actions" *saAllowedAccountRoles="['admin', 'dispatcher']">
    <button mat-raised-button color="primary" (click)="save()">Save</button>
  </div>
</div>
